import React from 'react';
import * as Css from './styles';

const Root = () => {
  return (
    <Css.Wrap>
      <h1>
        Rich V
        <span className="ufo-letter" role="img" aria-label="img">
          👽
        </span>
        ronov{' '}
      </h1>
      <h2>
        Front-end engineer{' '}
        <span className="flags">
          <span role="img" aria-label="img">
            🇷🇺 🇬🇧
          </span>
        </span>
      </h2>
      <Css.Item>
        <Css.Flex>
          <Css.Mail /> <p>Email:</p>{' '}
        </Css.Flex>
        <Css.Link href="mailto:richvoronov@gmail.com">
          richvoronov@gmail.com
          <Css.ExLink />
        </Css.Link>
      </Css.Item>
      <Css.Item>
        <Css.Flex>
          <Css.Telegram /> <p>Telegram:</p>{' '}
        </Css.Flex>
        <Css.Link
          href="https://t.me/richvoronov"
          target="_blank"
          rel="noreferrer noopener"
        >
          @richvoronov
          <Css.ExLink />
        </Css.Link>
      </Css.Item>
      <Css.Item>
        <Css.Flex>
          <Css.Github /> <p>Github:</p>{' '}
        </Css.Flex>
        <Css.Link
          href="https://github.com/richvoronov"
          target="_blank"
          rel="noreferrer noopener"
        >
          richvoronov
          <Css.ExLink />
        </Css.Link>
      </Css.Item>
      <Css.LinkItem to={'/sayhi'}>
        Say hi <span>{'>'}</span>
      </Css.LinkItem>
    </Css.Wrap>
  );
};

export default Root;
